import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { Form, Row } from 'react-bootstrap';

import BaseMapsSelector from '../../components/BaseMapsSelector';
import TablePagination from '../../components/TablePagination';
import SearchInput from '../../components/SearchInput';
import PageHeader from '../../atoms/PageHeader';

class LayerGallerySearchContainer extends Component {
  state = {
    totalCount: 0,
    currentPage: 1,
    searchValue: '',
    itemsPerPage: 1
  };

  componentDidMount() {
    const { pageToRestore } = this.props;
    this.changePage(pageToRestore);
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    const { currentPage } = this.state;
    const { savePage } = this.props;
    savePage(currentPage);
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateTotalCount = newCount => {
    this.setState(prevState => {
      if (prevState.totalCount !== newCount) {
        return { totalCount: newCount };
      }
      return null;
    });
  };

  updateDimensions = async () => {
    const windowSize = window.innerWidth;
    switch (true) {
      case windowSize < 300:
        this.setState({ itemsPerPage: 2 });
        break;
      case windowSize >= 300 && windowSize < 762:
        this.setState({ itemsPerPage: 6 });
        break;
      case windowSize >= 762 && windowSize < 997:
        this.setState({ itemsPerPage: 9 });
        break;
      case windowSize >= 997 && windowSize < 1230:
        this.setState({ itemsPerPage: 12 });
        break;
      case windowSize >= 1230 && windowSize < 1464:
        this.setState({ itemsPerPage: 15 });
        break;
      case windowSize >= 1464 && windowSize < 1699:
        this.setState({ itemsPerPage: 18 });
        break;
      default:
        this.setState({ itemsPerPage: 21 });
        break;
    }
  };

  changePage = pageNumber => {
    this.setState({ currentPage: pageNumber });
  };

  handleSearch = event => {
    event.persist();
    if (!isEmpty(event.target.value.trim())) {
      this.setState({ searchValue: event.target.value.trim(), currentPage: 1 });
    } else {
      this.setState({ searchValue: '', currentPage: 1 });
    }
  };

  render() {
    const { currentPage, itemsPerPage, totalCount, searchValue } = this.state;
    return (
      <>
        <Form.Group>
          <PageHeader>
            <Form.Label className="text-center">Layers</Form.Label>
            <div className="ml-auto">
              <SearchInput placeholder="Search layers..." onKeyUp={this.handleSearch} />
            </div>
          </PageHeader>
          <Row
            className="mb-5 mx-0 overflow-auto d-flex flex-row align-items-start"
            style={{ height: '60vh', justifyContent: 'space-between' }}
          >
            <BaseMapsSelector
              {...this.props}
              searchQuery={{
                search: searchValue,
                currentPage,
                perPage: itemsPerPage
              }}
              updateTotalCount={this.updateTotalCount}
            />
          </Row>
          <TablePagination
            totalCount={totalCount}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            changePage={this.changePage}
            isPaginationOn
          />
        </Form.Group>
      </>
    );
  }
}

LayerGallerySearchContainer.propTypes = {
  savePage: PropTypes.func.isRequired,
  pageToRestore: PropTypes.number.isRequired
};

export default LayerGallerySearchContainer;
